import { minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.white};
  padding: 0.5rem 2rem;
  width: 100%;
  text-align: center;
  margin-bottom: 0;
  ${({ margin }) => margin && `margin: ${margin}`};
  background-color: ${({ theme }) => theme.colors.black};
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}`};
  @media ${minWidthQueries.md} {
    clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%);
    padding: 0.5rem 10rem;
    width: auto;
    margin-bottom: 2rem;
  }
`

const TrapezoidTitle = ({ title, fontSize, margin }) => {
  return (
    <StyledTitle fontSize={fontSize} margin={margin}>
      {title}
    </StyledTitle>
  )
}

export default TrapezoidTitle
